// removed by extract-text-webpack-plugin
module.exports = {"container":"TopbarMenu__container__1H43I","sectionMainActions":"TopbarMenu__sectionMainActions__2OZZD","mainAction":"TopbarMenu__mainAction__2kdZO","separator":"TopbarMenu__separator__HYx8n","sectionOther":"TopbarMenu__sectionOther__1Yb9n","other":"TopbarMenu__other__rqT7Y","logout":"TopbarMenu__logout__19G6Y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TopbarMenu/TopbarMenu.css
// module id = 2132
// module chunks = 0